import { render } from "./BaileView.vue?vue&type=template&id=2daa84ac"
import script from "./BaileView.vue?vue&type=script&lang=js"
export * from "./BaileView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__